import { motion } from 'framer-motion';
import { Coins, HeartPulse, Briefcase, UserX, ShieldOff, HandHeart, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HEADS = [
  { icon: UserX, title: 'Deprivation of liberty', body: 'General damages recognised by our courts for time spent in custody — the longer and worse the conditions, the higher the award.' },
  { icon: HeartPulse, title: 'Contumelia', body: 'The affront to dignity, humiliation and psychological impact of being arrested and detained without lawful cause.' },
  { icon: Briefcase, title: 'Loss of income', body: 'Wages or income lost during the period of detention, or arising from consequential impact on employment.' },
  { icon: HandHeart, title: 'Medical & psychological expenses', body: 'Past and future medical costs where physical or psychological harm was caused by the arrest, assault in custody or detention conditions.' },
  { icon: ShieldOff, title: 'Assault in custody', body: 'A separate head of damages where injury was inflicted during arrest or detention — supported by medical evidence.' },
  { icon: Coins, title: 'Special / patrimonial losses', body: 'Any specific and quantifiable financial loss caused by the unlawful arrest or detention.' },
];

export default function DamagesSection() {
  return (
    <section data-testid="damages-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-inter font-bold uppercase tracking-[0.28em] text-[#FFD400]">Chapter 04 — What can be claimed</div>
          <h2 className="mt-4 font-poppins font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]">
            Heads of damages <span className="text-white/40">recognised in SA law.</span>
          </h2>
          <p className="mt-5 font-inter text-white/70 text-base md:text-lg leading-relaxed">
            Awards depend on the length of detention, conditions, injury and consequences. Leading authorities such as <em>Minister of Safety and Security v Tyulu</em> and <em>Woji v Minister of Police</em> guide the assessment.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {HEADS.map((h, i) => (
            <motion.div
              key={h.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
              data-testid={`damage-card-${i}`}
              className="group relative rounded-3xl border border-white/[0.06] bg-[#0d1826]/60 p-7 hover:border-[#0A84FF]/50 transition-colors"
            >
              <div className="text-[10px] font-inter font-bold uppercase tracking-[0.28em] text-white/40">0{i + 1}</div>
              <h.icon className="mt-4 h-6 w-6 text-[#39A8FF] group-hover:text-[#FFD400] transition-colors" strokeWidth={1.5} />
              <div className="mt-6 font-poppins font-semibold text-white text-lg leading-snug">{h.title}</div>
              <p className="mt-2 font-inter text-white/60 text-[13.5px] leading-relaxed">{h.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/calculator"
            data-testid="damages-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#FFD400] px-7 py-4 text-sm font-poppins font-bold uppercase tracking-wide text-[#07111F] hover:shadow-[0_0_40px_rgba(255,212,0,0.4)] transition-shadow"
          >
            See if you qualify <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
